import { useEffect } from 'react';

import { useIsAuthenticated } from '@azure/msal-react';
import { createFileRoute, useNavigate } from '@tanstack/react-router';

import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@frontend/components/ui/card';

export const Route = createFileRoute('/auth/callback/')({
  component: RouteComponent,
});

function RouteComponent() {
  const isAuthenticated = useIsAuthenticated();
  const navigate = useNavigate();

  useEffect(() => {
    // If authenticated, redirect to saved path or home after a short delay
    if (isAuthenticated) {
      const timer = setTimeout(() => {
        // Check if we saved a return path before MSAL redirect
        const returnPath =
          sessionStorage.getItem('__MSAL_REDIRECT_RETURN_PATH__') || '/';
        sessionStorage.removeItem('__MSAL_REDIRECT_RETURN_PATH__');

        navigate({ to: returnPath });
      }, 1500);

      return () => clearTimeout(timer);
    }
  }, [isAuthenticated, navigate]);

  // Show success and auto-redirect
  if (isAuthenticated) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-slate-50">
        <Card className="w-[350px]">
          <CardHeader>
            <CardTitle className="text-green-600">Success!</CardTitle>
            <CardDescription>
              You&apos;ve signed in successfully. Redirecting...
            </CardDescription>
          </CardHeader>
          <CardContent>
            <div className="flex justify-center">
              <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900"></div>
            </div>
          </CardContent>
        </Card>
      </div>
    );
  }

  // Show loading state while processing redirect
  return (
    <div className="flex items-center justify-center min-h-screen bg-slate-50">
      <Card className="w-[350px]">
        <CardHeader>
          <CardTitle>Completing sign-in...</CardTitle>
          <CardDescription>
            Please wait while we complete your authentication.
          </CardDescription>
        </CardHeader>
        <CardContent>
          <div className="flex justify-center">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900"></div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
